import React, { useEffect, useState } from "react";
import "./profile.scss";
import ProfileInfo from "./components/ProfileInfo";
import ProfileStats from "./components/ProfileStats";
import PoolsData from "./components/PoolsData";
import Loader from "../../shared/Loader";
import useWallet from "../../hooks/useWallet";
import usePoolCounts from "../../hooks/usePoolCounts";
import { useTheme } from "../../hooks/ThemeProvider";

const Profile = () => {
  // const [loading, setLoading] = useState(true);
  const { address } = useWallet();
    const { theme } = useTheme();
const [dummyData, setDummyData]= useState()

  // Get user-specific counts
  const {
    rootPoolsCount,
    childPoolsCount,
    loading: countsLoading
  } = usePoolCounts({
    userAddress: address,
    childPoolFilterBy: address, // Filter by creator
    autoFetch: true
  });
  // console.log("rootPoolsCount", rootPoolsCount,
    // childPoolsCount,);
  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 3000);
  // }, []);

  return (
    <>
      {/* {(loading || countsLoading) && <Loader />} */}
      <section className="rootpools_main">
    {
        theme === 'dark' ?    <img src="\assets\new.png" className="detailshade" />
          : <img src='\assets\whiteshade.png' className='detailshade' />
      }

        {/* <div className="formobileimg">
          <img
            src="\imagemobile.png"
            alt="img"
            className="img-fluid mobileimage d-none"
          />
        </div> */}

        <div className="custom-container">
          <div  className="inner_future lassstsidee">
 <ProfileInfo />
            <ProfileStats
              rootPoolsCount={rootPoolsCount}
              childPoolsCount={childPoolsCount}
              dummyData={dummyData}
            />
          </div>
          <div className="inner_future">

            <PoolsData
              rootPoolsCount={rootPoolsCount}
              childPoolsCount={childPoolsCount}
              setDummyData={setDummyData}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Profile;